import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  HostListener,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownOption } from './dropdown.model';
import { IconsComponent } from '@sml/icons';
import { FadeInAnimation } from '@sml/utility';

@Component({
  selector: 'sml-dropdown',
  standalone: true,
  imports: [CommonModule, IconsComponent],
  templateUrl: './dropdown.component.html',
  animations: [FadeInAnimation],
})
export class DropdownComponent {
  @Input() isOpen = false;
  @Input() options: DropdownOption[] = [];
  @Input() classes = '';
  @Input() completed=false;
  @Input() isExpired=false;
  @Input() campaignType:string='';
  @Output() optionClicked: EventEmitter<DropdownOption> = new EventEmitter<DropdownOption>();
  @Output() dropDownClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly elementRef: ElementRef
  ) { }

  onOptionClick(option: DropdownOption): void {
    this.optionClicked.emit(option);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
      this.dropDownClosed.emit(this.isOpen);
    }
  }
}
